<template>
  <div>
    <iframe
      src="https://metabase.saude.pa.gov.br/public/dashboard/3ac7d194-9f0b-43fb-81ea-4989f269b1ce?data=&matr%25C3%25ADcula=&nome=&rubrica=&setor_oficial=&status=&tab=12-plant%C3%B5es-e-sobreavisos"
      frameborder="0"
      scrolling="no"
      class="iframe-style"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.iframe-style {
  order: none;
  //top: 0;
  //left: 0;
  width: 100%;
  height: 70rem;
}
</style>
